var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "o-wrapper u-m-b7" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "o-grid" }, [
      _c("div", { staticClass: "o-grid__item u-width-full" }, [
        _c("div", { staticClass: "cards__wrapper", attrs: { id: "cards" } }, [
          _c(
            "div",
            { staticClass: "cards" },
            _vm._l(_vm.cards, function (card) {
              return _c("post-card-api", {
                key: card.id,
                attrs: { card: card },
              })
            }),
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "o-grid o-grid--center" }, [
      _c(
        "div",
        {
          staticClass: "post__click o-grid__item u-width-10/12 u-width-full@s",
        },
        [
          _c("div", { staticClass: "post__related" }, [
            _c("p", [_vm._v("Related posts")]),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }